import React, { useState } from "react";
import { sensorGraphs } from "../../services/sensors/sensorsService";
import { Image } from "react-bootstrap";

import SensorEditModal from "./SensorEditModal";

import { useNavigate } from "react-router-dom";
import SensorsUtils from "../utils/SensorsUtils";

const SensorCard = ({ values, onUpdate }) => {
  const [sensor, setSensor] = useState(values);
  const [showConfig, setShowConfig] = useState(false);
  const sensorName = values.name;
  const sensorDescription = values.description;
  const sensorNotifications = values.sendMail;
  const sensorCrop = values.crop;
  
  const navigate = useNavigate();

  const updateSensor = async (toGraph) => {
    if (localStorage.getItem("actual-sensor"))
      localStorage.setItem("actual-sensor", "");

    const sensorData = {
      ...sensor,
      ...(toGraph ? { checked: true } : {
        name: sensorName,
        crop: sensorCrop,
        description: sensorDescription,
        sendMail: sensorNotifications,
      }),
    };

    try {
      const response = await sensorGraphs(sensorData)

      localStorage.setItem("actual-sensor", JSON.stringify(response.data));

      if (toGraph)
        navigate("/graphs");
      else
        setSensor(response.data);
    } catch (error) {
      localStorage.removeItem("user-jwt");
      localStorage.removeItem("actual-sensor");
      navigate("/");
    }
  };

  const onClick = () => {
    if (!sensor.checked)
      updateSensor(true);
    else {
      if(sensor.sensorVariablesString == null)
        updateSensor(true);
      else{
        localStorage.setItem("actual-sensor", JSON.stringify(sensor));
        navigate("/graphs");
      }
    }
  };

  const handleShowConfig = () => setShowConfig(true);
  const handleHideConfig = () => {
    setShowConfig(false);
    if (onUpdate)
      onUpdate(sensor);
  }

  // const checkboxChange = () => {
  //   setSensorNotifications(!sensorNotifications);
  // };

  const sensorInfo = {
    active: sensor.active,
    checked: sensor.checked,
    id: sensor.id,
    name: sensorName,
    crop: sensorCrop?.crop,
    cropId: sensorCrop?.id,
    description: sensorDescription,
    sendMail: sensorNotifications,
    sim: sensor.sim,
    sensorVariablesString: sensor.sensorVariablesString,
    startOperation: sensor.startOperation
  };

  return (
    <div onClick={onClick} className={`
      flex flex-col w-80 rounded-xl text-black bg-gray-50 hover:bg-gray-200 shadow-md cursor-pointer
      ${sensor.checked ? 'border-none' : 'border-4 border-red-500'}
    `}>
      <div className="mx-4 mt-4 overflow-hidden rounded-xl bg-white text-gray-700">
        <div className="w-full aspect-[1/1]">
          <Image width={1104} height={736}
            src={SensorsUtils.getBackgroundSensor(sensor.crop?.crop)} 
            className="h-full w-full object-cover"
          />
        </div>
      </div>

      <div className="px-4 pt-4">
        <div className="flex items-center justify-between">
          <p className="block font-sans text-base font-medium text-black">
            {sensor.name}
          </p>

          <p className="block font-sans text-base font-medium text-black">
            {sensor.id}
          </p>
        </div>

        <div className="flex items-center">
          <p className="flex font-sans text-base font-medium items-center">
            <span className={`material-icons mr-2 ${sensor.active ? 'text-green-500' : 'text-red-500'}`}>{sensor.active ? 'check' : 'close'}</span> {sensor.active ? 'Activo' : 'Inactivo'}
          </p>
        </div>

        <p className="block font-sans text-sm text-justify font-normal leading-normal text-gray-700">
          <b>Sensor EnVIT:</b> dispositivo autónomo equipado con un panel solar y una batería. 
          Funciona hasta 3 años sin recalibración, garantizando datos precisos y confiables 
          para una gestión eficiente.
        </p>
      </div>

      <div className="flex items-center justify-center pb-2">
        {/* <button onClick={onClick} className="text-gray-700 hover:text-green-600 mr-2 transition duration-200"><span className="material-icons">visibility</span></button> */}
        <button onClick={(event) => {
          event.stopPropagation(); // Evita que el clic se propague al div padre
          handleShowConfig();
        }} className="text-blue-600 hover:text-green-600 transition duration-200"><span className="material-icons-outlined">edit</span></button>
      </div>

      {showConfig && 
        <div onClick={(e) => e.stopPropagation()}> {/* Evita la propagación aquí */}
          <SensorEditModal sensor={sensorInfo} onClose={handleHideConfig} onUpdate={setSensor} />
        </div>
      }
    </div>
  );
};

export default SensorCard;